import { Button } from '@cian/ui-kit';
import * as React from 'react';

export interface ICallbackButtonProps {
  onClick?(event: React.MouseEvent<HTMLButtonElement>): void;
  loading: boolean;
}

export const CallbackButton: React.VFC<ICallbackButtonProps> = ({ onClick, loading }) => {
  return (
    <Button
      onClick={onClick}
      size="M"
      theme="fill_secondary"
      type="button"
      data-testid="CallbackButton"
      fullWidth
      loading={loading}
    >
      Перезвоните мне
    </Button>
  );
};
